import { Outlet } from 'react-router-dom';
import { css } from '../styled-system/css';
import { Box, Flex } from '../styled-system/jsx';
import { fullScreen } from '../styled-system/patterns';
import { AuthProvider } from './auth/context/AuthContext';
import { TopNav } from './topNav/components/TopNav';

export const Public = () => {
  return (
    <AuthProvider>
      <Box
        className={css(fullScreen.raw(), {
          display: 'flex',
          flexDir: 'column',
        })}
      >
        <TopNav />
        <Flex alignItems="stretch" justifyContent="center" grow="1">
          <Outlet />
        </Flex>
      </Box>
    </AuthProvider>
  );
};
